import * as React from "react";
import { useAppDispatch, useAppSelector } from "app.hook";
import { useEffect, useState } from "react";
import {
  applyCoupon, removeCoupon,
  selectShoppingCart,
  setShoppingCart,
  updateGiftQuantity,
} from "states/shopping-cart/shopping-cart.slice";
import { closeConfirmModal, setLoading, showConfirmModal, showError } from "states/global-value/global-value.slice";
import { shallowEqual } from "react-redux";
import { appliedPromotionAPI } from "states/promotion/promotion.api";
import { ApplyPromotionRequestModel, PromotionCodeModel, PromotionCodeRequestModel, PromotionProductRequestModel, PromotionValueGiftModel, PromotionValueType } from "states/promotion/promotion.models";
import { ModalComponent } from "shared/components/modal/modal";
import { formatMoney, redirectFileLocalUrl } from "shared/plugins/string-helper";
import { IconClose, IconMinus, IconPlus } from "themes";
import { ConfirmModel } from "states/global-value/global-value.models";
import ShoppingCart, { ShoppingCartGiftItemModel } from "states/shopping-cart/shopping-cart.models";
import _ from "lodash";
import { checkFreeCondition } from "states/promotion-model-shared";

export interface IApplyCouponComponentProps {
  shoppingCart: ShoppingCart;
}

export function ApplyCouponComponent(props: IApplyCouponComponentProps) {
  const [code, setCode] = useState<string>("");
  const { shoppingCart } = props;
  const [promotion, setPromotion] = useState<PromotionCodeModel>({} as PromotionCodeModel);
  const [modalSelectProduct, setModalSetProduct] = useState<boolean>(false);
  const [category, setCategory] = useState<string>("");
  const dispatch = useAppDispatch();
  const _handleApplyCoupon = async () => {
    if (code === "") {
      dispatch(showError("Please enter coupon"));
      return;
    }
    dispatch(setLoading(true));
    try {
      let result = await appliedPromotionAPI({
        code: code,
        applyPromotionRequest: {
          subTotalAmount: shoppingCart.subTotal,
          branchId: shoppingCart.branch.id,
          products: shoppingCart.items.map(m => {
            return {
              id: m.productId,
              quantity: m.quantity,
            } as PromotionProductRequestModel
          }),
        } as ApplyPromotionRequestModel,
      } as PromotionCodeRequestModel);
      if (result.data.type === PromotionValueType.Discount) {
        dispatch(
          applyCoupon({
            discount: Number(shoppingCart.discount ?? 0) + Number(result.data.discountValue ?? 0),
            couponCode: code,
          })
        );
      } else {
        dispatch(
          applyCoupon({
            ...shoppingCart,
            couponCode: code,
          })
        );
        setModalSetProduct(true);
      }
      setPromotion(result.data);
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(
        removeCoupon(promotion.discountValue)
      );
      dispatch(setLoading(false));
      dispatch(showError(err.response?.data?.error?.message));
    }
  };
  const _handleRemoveCoupon = async () => {
    dispatch(
        removeCoupon(promotion.discountValue)
    );
    setPromotion({} as PromotionCodeModel);
  };
  const handleUpdateGiftQuantity = (index: number, quantity: number) => {
    dispatch(updateGiftQuantity({ index, quantity }));
  };
  const handleRenderCategoryDropdown = () => {
    let temp = { ...promotion };
    let groupByCategoryName = _.groupBy(temp.gifts, (m) => m.categoryName);
    let optionHtml = [];
    optionHtml.push(<option value="">-- Select Category --</option>);
    for (let key in groupByCategoryName) {
      optionHtml.push(<option value={key}>{key}</option>)
    }
    return <select value={category} onChange={(ev) => {
      setCategory(ev.target.value);
    }} className="form-control w-full py-2 mb-4">{optionHtml}</select>
  }
  const handleRenderGiftOfPromotion = (isSelected: boolean) => {
    let temp = { ...promotion };
    if (isSelected) {
      return temp.gifts.filter(m => shoppingCart.productOfGifts?.map(m => m.id)?.includes(m.id)).map((m) => {
        let productTemp = shoppingCart.productOfGifts.find(x => x.id === m.id);
        return (
          <React.Fragment>
            <div
              className="item-gift flex content-center items-start mb-4  rounded-md shadow-lg"
            >
              <div className="avatar-container">
                <div className="img-container rounded-md">
                  {m.image !== null ? (
                    <img
                      className="object-center rounded-md"
                      src={redirectFileLocalUrl(m.image ?? "")}
                      alt=""
                    />
                  ) : (
                    <div className="flex content-center rounded-md items-center avatar-thumb h-full w-full bg-yellow-50"></div>
                  )}
                </div>
              </div>
              <div className="info w-full">
                <div className="name ">
                  <span className="text-sm font-semibold uppercase">
                    {m.name} x {productTemp?.quantity ?? "1"}
                  </span>
                </div>
                <div className="flex justify-between content-center items-center">
                  <div className="text-red text-sm font-semibold uppercase">
                    {formatMoney(0, 2, ".", ",", "$")}
                  </div>
                </div>
              </div>
              <div className="icon">
                <IconClose
                  width={20}
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(
                      showConfirmModal({
                        title: "Confirm",
                        message: `Are you sure you want to delete this?`,
                        onYes: () => {
                          let productTemp = [...shoppingCart.productOfGifts];
                          if (productTemp.map(m => m.id).includes(m.id)) {
                            productTemp = productTemp?.filter(p => p.id !== m.id);
                          }
                          dispatch(
                            setShoppingCart({
                              ...shoppingCart,
                              productOfGifts: productTemp
                            })
                          );
                          dispatch(closeConfirmModal());
                        },
                      } as ConfirmModel)
                    );
                  }}
                />
              </div>
            </div>
          </React.Fragment>
        )
      })
    }
    return temp.gifts.filter(m => { return category === "" || m.categoryName === category }).map((m, index) => {
      let productTemp = shoppingCart.productOfGifts.find(x => x.id === m.id);
      return (<React.Fragment>
        <div
          className={`item-gift flex content-center items-start mb-4  rounded-md shadow-lg ${productTemp !== undefined ? `active` : ``}`}
        >
          <div className="avatar-container" onClick={() => {
            let productTemp = [...shoppingCart.productOfGifts];
            if (productTemp.map(m => m.id).includes(m.id)) {
              productTemp = productTemp?.filter(p => p.id !== m.id);
            } else {
              if (temp.numberOfGifts <= productTemp.map(m => m.quantity).reduce((a, b) => a + b, 0)) {
                dispatch(showError(`You can select up to ${temp.numberOfGifts} free item(s)`));
                return;
              }
              
              if (!checkFreeCondition({...promotion}, shoppingCart.productOfGifts,m.price, 1)) {
                dispatch(
                  showError(`You can select up to 0 free item(s)`)
                );
                return;
              }
              productTemp.push({
                id: m.id,
                quantity: 1,
                maxPrice: m.price,
              } as ShoppingCartGiftItemModel);
            }
            dispatch(
              setShoppingCart({
                ...shoppingCart,
                productOfGifts: productTemp
              })
            );
          }}>
            <div className="img-container rounded-md">
              {m.image !== null ? (
                <img
                  className="object-center rounded-md"
                  src={redirectFileLocalUrl(m.image ?? "")}
                  alt=""
                />
              ) : (
                <div className="flex content-center rounded-md items-center avatar-thumb h-full w-full bg-yellow-50"></div>
              )}
            </div>
          </div>
          <div className="info w-full">
            <div className="name" onClick={() => {
              let productTemp = [...shoppingCart.productOfGifts];
              if (productTemp.map(m => m.id).includes(m.id)) {
                productTemp = productTemp?.filter(p => p.id !== m.id);
              } else {
                if (temp.numberOfGifts <= productTemp.map(m => m.quantity).reduce((a, b) => a + b, 0)) {
                  dispatch(showError(`You can select up to ${temp.numberOfGifts} free item(s)`));
                  return;
                }
                let oldItem = promotion.gifts.find(
                  (x) => x.id === m.id
                );
                if (!checkFreeCondition({...promotion}, shoppingCart.productOfGifts,m.price, 1)) {
                  dispatch(
                    showError(`You can select up to 0 free item(s)`)
                  );
                  return;
                }
                productTemp.push({
                  id: m.id,
                  quantity: 1,
                  maxPrice: oldItem?.price,
                } as ShoppingCartGiftItemModel);
              }
              dispatch(
                setShoppingCart({
                  ...shoppingCart,
                  productOfGifts: productTemp
                })
              );
            }}>
              <span className="text-sm font-semibold uppercase">
                {m.name}
              </span>
            </div>
            {productTemp && (
              <div className="quantity-container flex place-content-center justify-between content-center items-center">
                <button
                  onClick={() => {
                    if (productTemp === undefined) {
                      return;
                    }
                    let productIndex = shoppingCart.productOfGifts.findIndex(m => m.id === productTemp?.id);
                    if (productTemp.quantity - 1 === 0) {
                      return;
                    }
                    handleUpdateGiftQuantity(productIndex, productTemp.quantity - 1);
                  }}
                  className="btn--default outline-none border-none p-2"
                >
                  <IconMinus width={20} />
                </button>
                <span className="text-md">{productTemp.quantity}</span>
                <button
                  onClick={() => {
                    if (productTemp === undefined) {
                      return;
                    }
                    let productIndex = shoppingCart.productOfGifts.findIndex(m => m.id === productTemp?.id);
                    if (
                      temp.numberOfGifts <
                      shoppingCart.productOfGifts
                        .filter((m) => m.id !== productTemp?.id)
                        .map((m) => m.quantity)
                        .reduce((a, b) => a + b, 0) +
                        productTemp.quantity +
                        1
                    ) {
                      dispatch(
                        showError(
                          `You can select up to ${temp.numberOfGifts} free item(s)`
                        )
                      );
                      return;
                    }
                    let quantity = productTemp.quantity;
                    if (!checkFreeCondition({...promotion}, shoppingCart.productOfGifts,m.price, 1)) {
                      dispatch(
                        showError(
                          `You can select up to ${quantity} free item(s)`
                        )
                      );
                      return;
                    }
                    handleUpdateGiftQuantity(productIndex, productTemp.quantity + 1);
                  }}
                  className="btn--default outline-none p-2"
                >
                  <IconPlus width={20} />
                </button>
              </div>
            )}
          </div>
          {productTemp && (
            <div className="icon">
              <IconClose
                width={20}
                className="cursor-pointer"
                onClick={() => {
                  let productTemp = [...shoppingCart.productOfGifts];
                  if (productTemp.map(m => m.id).includes(m.id)) {
                    productTemp = productTemp?.filter(p => p.id !== m.id);
                  }
                  dispatch(
                    setShoppingCart({
                      ...shoppingCart,
                      productOfGifts: productTemp
                    })
                  );
                }}
              />
            </div>
          )}

        </div>
      </React.Fragment>)
    })
  }

  useEffect(() => {
    _handleRemoveCoupon();
  }, [shoppingCart.items])
  return (
    <div className="promotion mt-2 mb-2">
      <h2 className="text-md font-semibold uppercase mb-2">Promotion Code</h2>
      <div className="form-promotion flex space-x-2 justify-between content-center items-center">
        <input
          type="text"
          value={code}
          placeholder="Enter your coupon code"
          className="px-3 py-2 w-full border border-gray-300"
          onChange={(ev) => {
            setCode(ev.target.value.toUpperCase());
          }}
          disabled={
            code === shoppingCart.couponCode && shoppingCart.couponCode !== ""
          }
          readOnly={
            code === shoppingCart.couponCode && shoppingCart.couponCode !== ""
          }
        />
        {code === shoppingCart.couponCode && shoppingCart.couponCode !== "" ? (
          <button
            onClick={_handleRemoveCoupon}
            className="btn--secondary px-8 py-1 uppercase font-semibold"
          >
            remove
          </button>
        ) : (
          <button
            onClick={_handleApplyCoupon}
            className="btn--secondary px-8 py-1 uppercase font-semibold"
          >
            apply
          </button>
        )}

      </div>
      {promotion?.type === PromotionValueType.Gift && (
        <React.Fragment>
          <button className="btn--primary w-full px-8 py-2 my-8 uppercase" onClick={() => {
            setModalSetProduct(true);
          }}>SELECT {promotion?.numberOfGifts} FREE ITEM(S)</button>
          <div className="gift-select-container">
            {handleRenderGiftOfPromotion(true)}
          </div>
          <ModalComponent
            width={`100%`}
            height={`100%`}
            isModal={false}
            className="w-full bg-white rounded-2xl"
            isCustomizeFooter={true}
            onCloseModal={() => {
              setModalSetProduct(false);
            }}
            isOpenModal={modalSelectProduct}
            title={`SELECT FREE ITEM(S)`}
          >
            <div className="pt-3">
              <div className="category-dropdown">
                {handleRenderCategoryDropdown()}
              </div>
              <div className="gifts-container">
                {handleRenderGiftOfPromotion(false)}
              </div>
              <div className="btn__container">
                <button onClick={() => { setModalSetProduct(false) }} className="btn--primary w-full px-8 py-4 uppercase font-semibold">Save</button>
              </div>
            </div>
          </ModalComponent>
        </React.Fragment>
      )}
    </div>
  );
}
